module.exports = __webpack_public_path__ + "static/img/12.e13a8ac.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/sp/12.png
// module id = OwBi
// module chunks = 0